import { InfoPanel } from "@risalabs_frontend_org/oasis-ui-kit";
import type { SingleCoverageInformation } from "../../../../data-model/coverageInformation";
import {
  formatDateToUTCWithFormat,
  formatDisplayDate,
} from "../../../../utils/formatDate";
import { EvCoverageSidebarLabeledValue } from "./evCoverageSidebarLabeledValue";

export interface EvCoverageSidebarProps {
  singleCoverage: SingleCoverageInformation;
}

export const EvCoverageSidebar = (props: EvCoverageSidebarProps) => {
  const { patientDemographics, providerInformation, orderInformation } =
    props.singleCoverage;

  return (
    <div className="ev-coverage-sidebar flex min-h-0 w-full min-w-0 flex-col gap-2 overflow-y-auto border-r border-dashed border-primaryGray-15 pr-2 md:gap-3 md:pr-4 lg:gap-4 lg:pr-5">
      <InfoPanel
        title="Patient Demographics"
        borderColor="#E5E7EB"
        className="!text-small !font-bold !leading-h11 !text-primaryGray-1"
      >
        <EvCoverageSidebarLabeledValue
          label="Date of Birth"
          value={formatDisplayDate(patientDemographics.dateOfBirth)}
        />
        <EvCoverageSidebarLabeledValue
          label="Sex"
          value={patientDemographics.gender || "—"}
        />
      </InfoPanel>
      <InfoPanel
        title="Provider Information"
        borderColor="#E5E7EB"
        className="!text-small !font-bold !leading-h11 !text-primaryGray-1"
      >
        <EvCoverageSidebarLabeledValue
          label="First Name"
          value={providerInformation.providerFirstName || "—"}
        />
        <EvCoverageSidebarLabeledValue
          label="Last Name"
          value={providerInformation.providerLastName || "—"}
        />
        <EvCoverageSidebarLabeledValue
          label="NPI"
          value={providerInformation.providerNPI || "—"}
        />
        <EvCoverageSidebarLabeledValue
          label="Tax ID"
          value={
            providerInformation.providerTaxID?.trim()
              ? providerInformation.providerTaxID
              : "Not Available"
          }
        />
      </InfoPanel>
      <InfoPanel
        title="Order Information"
        borderColor="#E5E7EB"
        className="!text-small !font-bold !leading-h11 !text-primaryGray-1"
      >
        <EvCoverageSidebarLabeledValue
          label="Date of Service"
          value={formatDateToUTCWithFormat(
            orderInformation.dateOfService,
            "MM/DD/YYYY",
            "—",
          )}
        />
      </InfoPanel>
    </div>
  );
};

export default EvCoverageSidebar;
